// extracted by mini-css-extract-plugin
export default {"nav":"LanguageSwitcher_nav__Li9ov","anchor":"LanguageSwitcher_anchor__Oz7zq","select":"LanguageSwitcher_select__+4h+C"};